import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import CustomDropdown from "../CustomDropdown";
import api from "../../services/axios";

const daysOptions = [
  { value: "Select", label: "Select" },
  { value: "today", label: "Today" },
  { value: 7, label: "Last 7 Days" },
  { value: 30, label: "30 Days" },
  { value: 180, label: "6 Months" },
  { value: 365, label: "12 Months" },
  { value: "ALL", label: "ALL" },
];

// Helper function to check if a date is in the selected range
function isDateInRange(dateStr, selectedDays) {
  if (selectedDays === "ALL" || selectedDays === "Select") return true;

  const date = new Date(dateStr);
  const today = new Date();
 today.setUTCHours(0, 0, 0, 0);
  if (selectedDays === "today") {
    // Check if same day
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  }

  // For numeric values like 7, 30, etc.
  if (typeof selectedDays === "number" || !isNaN(Number(selectedDays))) {
    const cutoff = new Date(today);
    cutoff.setDate(today.getDate() - Number(selectedDays) + 1); // +1 to include today
    return date >= cutoff && date <= today;
  }

  return false;
}

export default function UserCallByHourChart() {
  const [binnedData, setBinnedData] = useState(new Array(24).fill(0));
  const [selectedDays, setSelectedDays] = useState("ALL");

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await api.post("/getAllCallLogs", {
          filter: selectedDays,
        });

        if (res.data?.success && Array.isArray(res.data.data)) {
          const bins = new Array(24).fill(0);

          res.data.data.forEach((log) => {
            if (!log.start_stamp) return;

            // Filter based on selectedDays
            if (!isDateInRange(log.start_stamp, selectedDays)) return;

         const hour = new Date(log.start_stamp).getUTCHours();

            bins[hour]++;
          });

          setBinnedData(bins);
        }
      } catch (err) {
        console.error("Error fetching call logs:", err);
      }
    };

    fetchLogs();
  }, [selectedDays]);

  const handleChange = (val) => {
    setSelectedDays(val);
  };

  const hourLabels = Array.from({ length: 24 }, (_, i) => `${i} Hours`);
  const maxVal = Math.max(...binnedData);
  const seriesData = binnedData.map((count) => ({
    y: count,
    color: count === maxVal && count > 0 ? "#FF0000" : "#999999",
  }));

  const chartOptions = {
    chart: { type: "column", backgroundColor: "transparent" },
    title: { text: null },
    xAxis: {
      categories: hourLabels,
      title: {
        text: "",
        style: { fontWeight: "bold" },
      },
      labels: { rotation: -45, style: { fontSize: "10px" } },
    },
    yAxis: {
      title: { text: "Number of Calls" },
      allowDecimals: false,
    },
    series: [{ name: "Calls", data: seriesData }],
    credits: { enabled: false },
    legend: { enabled: false },
    
    tooltip: {
      formatter() {

        
        return `<strong>Hour:</strong> ${this.x}<br/><strong>Calls:</strong> ${this.y}`;
      },
    },
  };

  return (
    <div className="assisvia">
      <div className="assisvia-header d-flex justify-content-between">
     
       <h2 className="heatmap-title">User Hourwise Call Frequency</h2>

        <div className="selectinput">
          <CustomDropdown
            options={daysOptions}
            placeholder="Select Days"
            onChange={handleChange}
            name="days"
              className="selectinput"
            value={selectedDays}
          />
        </div>
      </div>

      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
}
